module.exports = __webpack_public_path__ + "img/nextPage1.b09e2aa6.png";